// extracted by mini-css-extract-plugin
module.exports = {"prevButton":"prev-arrow_prevButton__wnL5q","buttonContainer":"prev-arrow_buttonContainer__Yo479"};